import {IconButton, Skeleton} from '@mui/material';
import LocalMallIcon from '@mui/icons-material/LocalMall';
import React, {FC} from 'react';
import {useAppSelector} from '../../hooks/storeHooks';
import {Output, RatePlanItem} from '../../contexts/Configuration';
import {calculateAvailableMinutes} from '../../utils/BillingUtils';

const BalanceSummary: FC<BalanceSummaryProps> = ({}) => {
    const credit = useAppSelector((state) => state.billing.balanceCredit) as number;
    const ratePlanItems = useAppSelector((state) => state.billing.ratePlanItems) as RatePlanItem[];
    const waitingForBalance = useAppSelector((state) => state.billing.waitingForBalance) as boolean;


    const sessionStarted = useAppSelector((state) => state.session.sessionStarted) as boolean;
    const outputs = useAppSelector(state => state.session.outputs) as Output[];

    //calculates the estimated consumed minutes

    const totalMinAvailable = calculateAvailableMinutes(outputs, ratePlanItems, credit || 0);


    if (waitingForBalance)
        return (
            <div className="nav-bar-balance">
                <div className="nav-bar-balance-credit">
                    <IconButton href="/billing" disabled={sessionStarted}>
                        <LocalMallIcon className="nav-bar-balance-credit-icon"/>
                    </IconButton>
                    <div>Balance</div>
                </div>
                <div className="nav-bar-balance-amount">
                    <Skeleton variant="text"/>
                </div>
                <div className="nav-bar-balance-consumption">
                    <Skeleton variant="text"/>
                </div>
            </div>
        );

    return (
        <div className="nav-bar-balance">
            <div className="nav-bar-balance-credit">
                <IconButton href="/billing" disabled={sessionStarted}>
                    <LocalMallIcon className="nav-bar-balance-credit-icon"/>
                </IconButton>
                <div>Balance</div>
            </div>
            <div className="nav-bar-balance-amount">
                {`$ ${credit}`}
            </div>
            <div className="nav-bar-balance-consumption">
                {`${totalMinAvailable} Available minutes`}
            </div>
        </div>
    );
}

type BalanceSummaryProps = {}

export default BalanceSummary;